import { RootMessageBoardState } from "~/messageBoard/types";

export const getAiCompletion = (state: RootMessageBoardState) => state.messageBoard?.aiCompletion;
export const getAiSuggestion = (state: RootMessageBoardState) => state.messageBoard?.aiCompletion?.suggestion;
export const isAiCompletionActive = (state: RootMessageBoardState) => !!state.messageBoard?.aiCompletion;
